import React, { useState } from "react";
import "./video.css";
import Footer from "./footer";

const Video = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const videos = [
    "https://www.youtube.com/watch?v=pQ23bJFy0AQ",
    "https://www.youtube.com/watch?v=mKmeyvYfJHQ",
    // "https://www.youtube.com/watch?v=mKmeyvYfJHQ",
  ];

  return (
    <div className="video-section">
      <div className="video-wrapper">
        {/* Header Section */}
        <div className="video-header">
          <div className="badge">
            <span>Video Gallery</span>
          </div>
          <h2 className="main-title">
            Our <span className="gradient-text">Videos</span>
          </h2>
          <p className="subtitle">
            Discover our collection of engaging content
          </p>
        </div>

        {/* Video Grid */}
        <div className="video-grid">
          {videos.map((videoUrl, index) => {
            const videoId = videoUrl.split("v=")[1]?.split("&")[0];
            const embedUrl = `https://www.youtube.com/embed/${videoId}`;

            return (
              <div
                key={index}
                className={`video-card ${hoveredIndex === index ? 'hovered' : ''}`}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
              >
                <div className="card-container">
                  <div className="glow-effect"></div>
                  
                  <div className="video-frame">
                    <iframe
                      src={embedUrl}
                      title={`YouTube video ${index + 1}`}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    ></iframe>
                  </div>

                  <div className="video-info">
                    <span className="video-number">Video {index + 1}</span>
                    <div className="status-indicator">
                      <div className="status-dot"></div>
                      <span className="status-text">
                        {hoveredIndex === index ? 'Watching' : 'Ready'}
                      </span>
                    </div>
                  </div>

                  <div className="accent-line"></div>
                </div>

                {hoveredIndex === index && (
                  <>
                    <div className="particle particle-1"></div>
                    <div className="particle particle-2"></div>
                  </>
                )}
              </div>
            );
          })}
        </div>

        {/* Bottom Decoration */}
        <div className="bottom-decoration">
          <div className="decoration-line line-left"></div>
          <span>Scroll to explore more</span>
          <div className="decoration-line line-right"></div>
        </div>
      </div>
      <div>
        <Footer/>
      </div>
    </div>
        
  );
  
};

export default Video;